<template>
<!--我的订单-->
  <div class="orders">
    <headers></headers>
    <div class="padding250">
      <div class="auto">
        <div class="titleWrap">
          <p class="titleName">申报记录</p>

        </div>
          <ul class="orderOut">
            <li>
              <p class="title">2020年美国大学研学考察活动申报</p>
               2020-02-10  09:36 <br>活动时间：2020-04-10 <br> 申报时间：2020-01-01
               <a href="javascript:;">审核通过</a>
            </li>
            <li>
              <p class="title">2020年美国大学研学考察活动申报</p>
               2020-02-10  09:36 <br>活动时间：2020-04-10 <br> 申报时间：2020-01-01
               <a href="javascript:;" class="no">审核未通过</a>
            </li>
          </ul>


        <div class="pageout"><Page :total="100" /></div>
      </div>
    </div>


<footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .auto{
    background: #fff;
    margin-top: 30px;
    padding: 40px;
  }
  .pageout {
    text-align: center;
    margin-top: 35px;
    height: 34px;
  }
  .titleWrap {
    height: 40px;
    font-size: 16px;
    padding-bottom: 20px;
    color: #333;
    text-align: justify-all;
    border-bottom: 1px solid #E1E1E1;
    .titleName {
      float: left;
      line-height: 24px;
    }

  }
  .orderOut li {
    border-bottom: 1px solid #E1E1E1;
    padding: 20px 0;
    position: relative;
    font-size: 14px;
    color: #666;
        text-align: left;
    .title{
      font-size: 16px;
      color: #000;
      margin-bottom: 10px;
    }
    a{
      color: #fff;
      font-size: 16px;
      background-color: #ccc;
      position: absolute;
      top:40px;
      right: 0;
      display: block;
      width: 120px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      border-radius: 5px;
      &.no{
        background-color: #FF6666;
      }
    }

  }
</style>
<script type="text/ecmascript-6">
import headers from '../template/header'
  import footers from '../template/footer'
    export default {
        name: 'jilu',
        props: {},
        data() {
            return {
              edit:true
            };
        },
        methods: {
          toggle(){
              this.edit=!this.edit;
          }
        },
        created() {

        },
        components: {
headers,
     footers
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/education/shenbaojilu.vue